import useGet from "#hooks/useGet.js";
import { AdminLayout, CardLayout } from "#layouts";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import { CustomChart } from "#UI";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function AdminDashboard() {
  const { t } = useTranslation();
  const [viewMode, setViewMode] = useState("monthly");
  const { data: dashboardData, isLoading: isDashboardLoading } = useGet(
    ENDPOINTS.DASHBOARD,
    [QUERY_KEYS.DASHBOARD_QUERY_KEY]
  );
  console.log(dashboardData, "dashboardData");
  const data = dashboardData?.data;

  return (
    <AdminLayout>
      <section className="common-section spacer">
        <div className="container">
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-3 g-4">
            <CardLayout>
              <div className="dashboard-card-content">
                <h3 className="txt-heading-clr">
                  Total Agronomists Registered
                </h3>
              </div>
              <div className="dashboard-card-top-stats">
                <div>
                  <p>{t("Today")}</p>
                  <span>{data?.todayAgros ?? 0}</span>
                </div>
                <div>
                  <p>{t("This Week")}</p>
                  <span>{data?.weekAgros ?? 0}</span>
                </div>
                <div>
                  <p>{t("This Month")}</p>
                  <span>{data?.monthAgros ?? 0}</span>
                </div>
              </div>
            </CardLayout>
            <CardLayout>
              <div className="dashboard-card-content">
                <h3 className="txt-heading-clr">Total Growers</h3>
              </div>
              <div className="dashboard-card-top-stats">
                <div>
                  <p>Today</p>
                  <span>{data?.todayGrowers ?? 0}</span>
                </div>
                <div>
                  <p>{t("This Week")}</p>
                  <span>{data?.thisWeekGrowers ?? 0}</span>
                </div>
                <div>
                  <p>{t("This Month")}</p>
                  <span>{data?.thisMonthGrowers ?? 0}</span>
                </div>
              </div>
            </CardLayout>
            <CardLayout>
              <div className="dashboard-card-content">
                <h3 className="txt-heading-clr">Total Number of Scouting</h3>
              </div>
              <div className="dashboard-card-top-stats">
                <div>
                  <p>Today</p>
                  <span>{data?.todayScouting ?? 0}</span>
                </div>
                <div>
                  <p>This Week</p>
                  <span>{data?.weekScouting ?? 0}</span>
                </div>
                <div>
                  <p>This Month</p>
                  <span>{data?.monthScouting ?? 0}</span>
                </div>
              </div>
            </CardLayout>
            <CardLayout>
              <div className="dashboard-card-content">
                <h3 className="txt-heading-clr">Total Crop Plan</h3>
              </div>
              <div className="dashboard-card-top-stats">
                <div>
                  <p>Today</p>
                  <span>{data?.todayCropPlan ?? 0}</span>
                </div>
                <div>
                  <p>This Week</p>
                  <span>{data?.weekCropPlan ?? 0}</span>
                </div>
                <div>
                  <p>This Month</p>
                  <span>{data?.monthCropPlan ?? 0}</span>
                </div>
              </div>
            </CardLayout>
          </div>

          <div className="graph_wrapper mt-5">
            <div className="row">
              <div className="col-md-12 col-lg-8">
                <div className="graph-cards bg-white">
                  <div className="graph-cards-top-blk">
                    <h2 className="txt-heading-clr">Total Agronomists</h2>
                    <div className="select-field-wrapper">
                      <div className="select-field-inner-blk position-relative">
                        <select
                          className="form-select select-dropdown position-relative"
                          value={viewMode}
                          onChange={(e) => setViewMode(e.target.value)}
                        >
                          <option value="weekly">Weekly</option>
                          <option value="monthly">Monthly</option>
                          <option value="yearly">Yearly</option>
                        </select>
                        {/* <img
                          className="calender-icon position-absolute top-1"
                          src="/assets/images/icons/calendar-icon.svg"
                          alt="calender-icon"
                        /> */}
                      </div>
                    </div>
                  </div>
                  <CustomChart
                    viewMode={viewMode}
                    weeklyGraphData={data?.weeklyGraphData ?? []}
                    monthlyGraphData={data?.monthlyGraphData ?? []}
                    yearlyGraphData={data?.yearlyGraphData ?? []}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </AdminLayout>
  );
}
